import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { CONFIG } from '@core/config';
import { map } from 'rxjs';

/** Shared viewport breakpoints for services and components that adapt to mobile. */
@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  readonly isMobile$ = inject(BreakpointObserver)
    .observe(CONFIG.MOBILE_MEDIA_QUERY)
    .pipe(map(state => state.matches));
}
